<div class="form">
  <div class="dx-fieldset">
    <!-- Bordi Griglia -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Visualizza i bordi della griglia
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-switch
          [(value)]="gridConf.showBorders"
          [hoverStateEnabled]="false"
        ></dx-switch>
      </div>
    </div>
    <!-- Righe alternate -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Colora le righe in maniera alternata (Sempre disabilitato se ci sono
        stili impostati)
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-switch
          [(value)]="gridConf.rowAlternationEnabled"
          [hoverStateEnabled]="false"
        ></dx-switch>
      </div>
    </div>
    <!-- Righe selezionata -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Evidenzia la riga selezionata
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-switch
          [(value)]="gridConf.hoverStateEnabled"
          [hoverStateEnabled]="false"
        ></dx-switch>
      </div>
    </div>
    <!-- Mosta colonne -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Visualizza le linee delle colonne
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-switch
          [(value)]="gridConf.showColumnLines"
          [hoverStateEnabled]="false"
        ></dx-switch>
      </div>
    </div>
    <!-- Mosta colonne -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Visualizza le linee delle righe
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-switch
          [(value)]="gridConf.showRowLines"
          [hoverStateEnabled]="false"
        ></dx-switch>
      </div>
    </div>
  </div>
</div>
